import {useEffect, useRef, useState} from "react";
import iconFileTextOutline from "@iconify/icons-eva/file-text-outline";
import iconFileAddOutline from "@iconify/icons-eva/file-add-outline";
import iconPaperPlaneOutline from "@iconify/icons-eva/paper-plane-outline";
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Switch,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
  Divider,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Box,
  Tooltip,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import {OrderListToolbar} from "../../components/_dashboard/order";

import axios from "axios";
import moment from "moment";
import {
  PAY_METHODS,
  PAY_METHOD_MAP,
  STORE_ORDER_STATUS,
  STORE_ORDER_STATUS_MAP,
  DELIVERY_TYPE_MAP
} from "src/config/constants";
import {alert} from "src/services/alert";
import MoreMenu from "src/components/common/MoreMenu";
import XLSX from "xlsx";
import FormDialog from "src/components/common/FormDialog";
import ConvertUtil from "src/utils/ConvertUtil";
import Confirm from "src/components/common/ConfirmDialog";
import ListHead from "src/components/common/ListHead";
import OrderRecordsDialog from "src/components/dialogs/OrderRecordsDialog";
import {asyncRequest} from "src/services/network";
import OrderDetailDialog from "src/components/dialogs/OrderDetailDialog";
import UserInfo from "src/components/common/UserInfo";
import CellImage from "src/components/common/CellImage";
import StoreOrderAddDialog from "./components/StoreOrderAddDialog";
import {Icon} from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import ListToolbar from "src/components/common/ListToolbar";
import MerchantPicker from "src/components/common/MerchantPicker";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";
import UserPicker from "src/components/common/UserPicker";
import SupplierPicker, {SupplierPickerDialog} from "src/components/common/SupplierPicker";
import StoreProductPicker from "src/components/common/StoreProductPicker";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/zh-cn";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import {useSelector} from "react-redux";
import {getStoreSections} from "src/services/request";// ----------------------------------------------------------------------

const payMethods = Object.values(PAY_METHODS);

const TABLE_HEAD = [
  {id: "name", label: "购买用户", alignRight: false},
  {id: "orderSN", label: "商品信息", alignRight: false},
  {id: "buyCount", label: "支付详情", alignRight: false},
  {id: "receiver", label: "物流信息", alignRight: false},
  {id: "supplier", label: "供应商", alignRight: false},
  //{id: "productName", label: "商品名称", alignRight: false},
  {id: "settle", label: "是否对账", alignRight: false},
  // {id: "deductionXfqV2", label: "消费券", alignRight: false},
  // {id: "buyCount", label: "购买数量", alignRight: false},
  // {id: "totalPrice", label: "商品总价(元)", alignRight: false},
  // {id: "price", label: "支付金额(元)", alignRight: false},
  // {id: "payMethod", label: "支付方式", alignRight: false},
  //{id: "status", label: "状态", alignRight: false},
  // {id: "points", label: "赠送积分", alignRight: false},

  // { id: "receiverName", label: "收件人", alignRight: false },
  // { id: "receiverMobile", label: "收货人号码", alignRight: false },
  // { id: "receiverAddress", label: "收货地址", alignRight: false },
  // {id: "userRemark", label: "买家留言", alignRight: false},
  //{id: "createdAt", label: "下单时间", alignRight: false},
  {id: ""},
];

const moreMenus = [
  // { title: "详情", icon: iconFileTextOutline },
  {title: "记录", icon: iconFileTextOutline},
  {title: "备注", icon: iconFileAddOutline},
  {title: "取消订单", icon: iconFileAddOutline},
  {title: "发货", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED]},
  {title: "退款", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.REFUNDING]},
  // { title: "确认支付", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PENDING] },
  {
    title: "删除",
    icon: iconPaperPlaneOutline,
    limit: [STORE_ORDER_STATUS.FINISHED, STORE_ORDER_STATUS.DELETED, STORE_ORDER_STATUS.CANCELED]
  },
];

const statuses = Object.values(STORE_ORDER_STATUS);
const remarkList = [{
  value: '商品无货',
  label: '商品无货',
}, {
  value: '地址错误',
  label: '地址错误',
}, {
  value: '客户要求取消',
  label: '客户要求取消',
}]

export function MerchantOrderList() {
  const {storeSections, sectionMap} = useSelector((state) => state.globalData);
  const [curOrder, setCurOrder] = useState({});
  const [action, setAction] = useState();
  const [remark, setRemark] = useState("");
  const [syncRemark, setSyncRemark] = useState("");
  const [deliverySN, setDeliverySN] = useState(""); // 物流信息
  const [orders, setOrders] = useState([]);
  const [records, setRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [countMap, setCountMap] = useState({});
  const [product, setProduct] = useState({});
  const [supplier, setSupplier] = useState({});
  const uploadRef = useRef();

  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    status: [],
    search: "",
    orderSN: "",
    deliverySN: "",
    uid: "",
    createdAt: null,
    productId: null,
    supplierId: null,
    sectionId: null,
    startTime: null,
    endTime: null,
    deliveryType: null,
    payMethod: -1,
  });

  useEffect(() => {
    getStoreSections();
  }, []);

  useEffect(() => {
    getOrders();
  }, [filter]);

  async function getOrders() {
    const {data, count, counts} = await asyncRequest({
      path: "/store/order/list",
      data: filter,
    });

    setOrders(
      data.map((d) => ({
        ...d,
        createdAt: moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        payTime: d.payTime ? moment(d.payTime).format("YYYY-MM-DD HH:mm:ss") : d.payTime,
        productData: JSON.parse(d.productData) || [],
        // productName: JSON.parse(d.productData)[0].name,
      }))
    );
    setTotalItems(count);

    // const map = {};
    // for (let i = 0; i < counts.length; i++) {
    //   map[counts[i].status] = counts[i].count;
    // }
    // setCountMap(map);
  }

  function handleSearch(val) {
    setFilter({
      ...filter,
      search: val,
    });
  }

  const handleChangePage = (event, newPage) => {
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter({
      ...filter,
      size: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  function handleDateChange(dateRange) {
    setFilter({
      ...filter,
      createdAt: dateRange,
    });
  }

  function handleStatusChange(status) {
    setFilter({
      ...filter,
      status,
    });
  }

  function handleReset() {
    setFilter({
      page: 0,
      size: 20,
      status: [],
      payMethod: -1,
      search: "",
      createdAt: null,
      deptId: null,
      districtId: null,
      productId: null,
      supplierId: null,
      uid: "",
      mid: "",
      orderSN: "",
      startTime: null,
      endTime: null,
    });
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      page: 0,
      [ki]: val,
    });
  }

  function remarkChange(val) {
    setSyncRemark(val);
  }

  // 操作条
  async function handleDownload() {
    const {msg} = await asyncRequest({
      path: "/store/order/export",
      data: filter,
    });
    alert(msg, "success");
  }

  // 供应链导出
  async function handleSupplyChainExport() {
    const { data } = await asyncRequest({
      path: "/store/order/supplyChainExport",
      data: filter,
    });

    exportOrders(data.map((d) => ({ ...d, createdAt: moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss"), payTime: d.payTime ? moment(d.payTime).format("YYYY-MM-DD HH:mm:ss") : d.payTime })));
  }

  function exportOrders(orders) {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    const cellTitles = ["是否对账", "订单号", "收货人姓名", "收货人电话", "收货地址", "供应商", "商品专区", "商品编号", "商品名称", "权益金抵扣", "兑换券抵扣", "消费券抵扣", "数量", "总价格", "实际支付", "供应商成本价", "平台成本价", "运费", "下单时间", "支付方式", "支付状态", "支付时间", "赠送积分", "用户备注", "管理员备注", "物流单号", "购买人UID"];
    const cellKeys = ["settle", "orderSN", "receiverName", "receiverMobile", "receiverAddress", "supplierName", "sectionName", "productId", "productName", "deductionXfqV2", "deductionDhqV2", "deductionXfqV2Bak", "buyCount", "totalPrice", "payPrice", "supplierCost", "cost", "shippingFee", "createdAt", "payMethod", "status", "payTime", "points", "userRemark", "adminRemark", "deliverySN", "uid"];
    const header = alphabets.slice(0, cellTitles.length);

    const _orders = orders.map((order) => {
      const productData = typeof order.productData === 'string' ? JSON.parse(order.productData) : (order.productData || []);
      const p = productData[0] || {};
      
      return {
        ...order,
        settle: order.settle ? "TRUE" : "FALSE",
        receiverName: order.receiverName || "",
        receiverMobile: order.receiverMobile || "",
        receiverAddress: order.receiverAddress || "",
        supplierName: order.supplier?.name || "",
        sectionName: p.sectionName || "",
        productId: p.id || order.productId || "",
        productName: p.name || order.productName || "",
        buyCount: p.count || order.buyCount || 1,
        payMethod: PAY_METHOD_MAP[order.payMethod] || "",
        status: STORE_ORDER_STATUS_MAP[order.status] || "",
        createdAt: order.createdAt ? moment(order.createdAt).format("YYYY-MM-DD HH:mm:ss") : "",
        payTime: order.payTime ? moment(order.payTime).format("YYYY-MM-DD HH:mm:ss") : "",
        uid: order.uid || "", // 购买人UID
      };
    });

    const data = [];
    data[0] = {};
    for (let i = 0; i < header.length; i++) {
      const alphabet = header[i];
      data[0][alphabet] = cellTitles[i];

      for (let j = 0; j < _orders.length; j++) {
        if (!data[j + 1]) {
          data[j + 1] = {};
        }

        data[j + 1][alphabet] = _orders[j][cellKeys[i]];
      }
    }

    var ws = XLSX.utils.json_to_sheet(data, { header, skipHeader: true });

    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, "订单信息");

    const now = moment();
    const fileName = `${now.format('YYYY.MM.DD')}供应链导出.xlsx`;
    XLSX.writeFile(workbook, fileName);
  }

  function filterMoreMenus(status) {
    const menus = [];
    for (let i = 0; i < moreMenus.length; i++) {
      if (moreMenus[i].limit && !moreMenus[i].limit.includes(status)) {
        continue;
      }

      menus.push(moreMenus[i]);
    }

    return menus;
  }

  async function getOrderRecords(orderSN) {
    const {data} = await asyncRequest({
      path: "/store/order/records",
      data: {orderSN},
    });

    setRecords(data);
    setAction("records");
  }

  // 更多操作
  function handleMoreClick(title, row, ...args) {
    if (title === "详情") {
      setCurOrder(row);
      setAction("detail");
    } else if (title === "记录") {
      // setAction("records");
      getOrderRecords(row.orderSN);
    } else if (title === "发货") {
      setCurOrder(row);
      setAction("delivery");
    } else if (title === "备注") {
      setCurOrder(row);
      setRemark(row.adminRemark);
      setAction("remark");
    } else if (title === "退款") {
      refund(row.orderSN);
    } else if (title === "删除") {
      delRow(row.orderSN);
    } else if (title === "取消订单") {
      setCurOrder(row);
      setSyncRemark(row.adminRemark);
      setAction("cancel");
    } else if (title === "确认支付") {
      confirmPay(row.orderSN);
    } else if (title === "settle") {
      settleFun(row);
    }
  }

  function handleDialogConfirm() {
    if (action === "remark") {
      setAdminRemark();
    } else if (action === "delivery") {
      fahuo();
    }
  }

  async function syncRemarkConfirm() {
    const {msg} = await asyncRequest({
      path: "/store/order/cancel",
      data: {orderSN: curOrder.orderSN, sysRemark: syncRemark},
    });
    alert(msg, "success");
    setAction();
    getOrders();
  }

  async function setAdminRemark() {
    const {data} = await asyncRequest({
      path: "/store/order/remark",
      data: {orderSN: curOrder.orderSN, remark},
    });

    orders.find((t) => t.orderSN === curOrder.orderSN).adminRemark = remark;
    setOrders([...orders]);

    setAction();
  }

  async function fahuo() {
    const {data} = await asyncRequest({
      path: "/store/order/fahuo",
      data: {orderSN: curOrder.orderSN, deliverySN: deliverySN},
    });

    setOrders(orders.filter((t) => t.orderSN !== curOrder.orderSN));
    setAction();
    setDeliverySN("");
  }

  async function confirmPay(orderSN) {
    const {msg} = await asyncRequest({
      path: "/store/order/confirmPay",
      data: {orderSN},
    });

    setOrders(orders.filter((t) => t.orderSN !== orderSN));
    alert(msg, "success");
  }

  async function settleFun(row) {
    const {msg} = await asyncRequest({
      path: "/store/order/setSettle",
      data: {
        orderSN: row.orderSN,
        settle: row.settle == true ? false : true,
      },
    });
    alert(msg, "success");
    getOrders()
  }

  function refund(orderSN) {
    Confirm({
      message: "确认退款吗？",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/store/order/refund",
          data: {orderSN},
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function delRow(orderSN) {
    Confirm({
      message: "确定删除该条数据吗?",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/store/order/del",
          data: {orderSN},
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function handleUpload(e, type) {
    console.log(e);
    if (!e.target.files[0]) return;
    let reader = new FileReader();
    reader.onload = (event) => {
      uploadRef.current.value = null;
      try {
        // 判断文件类型是否正确
        // if (".xls" != suffix && ".xlsx" != suffix) {
        //     message.error("选择Excel格式的文件导入!");
        //     return false;
        // }
        let {result} = event.target;
        // 读取文件
        let workbook = XLSX.read(result, {type: "binary"});
        let data = [];
        // 循环文件中的每个表
        let loaded = false;
        for (let sheet in workbook.Sheets) {
          // console.log('sheet: ', sheet);
          // if (workbook.Sheets.hasOwnProperty(sheet)) {
          //   // 将获取到表中的数据转化为json格式
          // }
          if (loaded) continue;

          const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {defval: ""});
          console.log(sheetData);
          // setInitialData(sheetData);
          // setShowImportDialog(true);
          if (type === 'settle') {
            handleBulkSettle([...sheetData])
          } else {
            handleBulkSend([...sheetData]);
          }
          loaded = true;
        }
        // console.log("data:", data);
      } catch (e) {
        console.log(e);
        alert("文件类型不正确！");
      }
    };
    reader.readAsBinaryString(e.target.files[0]);
    // console.log(e.target.files[0])
  }

  function handleBulkSend(items) {
    Confirm({
      message: "确定批量发货吗？",
      async onConfirm() {
        const orders = [];

        for (let index = 0; index < items.length; index++) {
          const order = items[index];

          if (!order["物流单号"]) continue;

          orders.push({
            orderSN: order["订单号"],
            deliverySN: order["物流单号"],
            deliveryCompany: order["物流公司"],
          });
        }

        console.log(orders, items);

        // return;

        const {msg} = await asyncRequest({
          path: "/store/order/bulkFahuo",
          data: {orders},
        });

        alert(msg, "success");
        getOrders();
      },
    });
  }

  function handleBulkSettle(items) {
    Confirm({
      message: "确定批量设置对账状态吗？",
      async onConfirm() {
        const orders = [];
        for (let index = 0; index < items.length; index++) {
          const order = items[index];
          orders.push({
            orderSN: order["订单号"],
            isSettle: order["是否对账"],
          });
        }
        console.log(orders, items);
        const {msg} = await asyncRequest({
          path: "/store/order/bulk/settle",
          data: {orders},
        });
        alert(msg, "success");
        getOrders();
      },
    });
  }

  async function handleExport() {
    const {data, msg} = await asyncRequest({
      path: "/store/order/export",
      data: filter,
    });

    alert(msg, "success");
  }

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - orders.length) : 0;
  const emptyRows = 0;

  return (
    <Page title="商城订单">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            商城订单
          </Typography>

          <Button
            variant="contained"
            startIcon={<Icon icon={plusFill}/>}
            onClick={() => {
              setAction("addOrder");
            }}
          >
            添加订单
          </Button>
        </Stack>

        <Card>
          {/* <OrderListToolbar total={totalItems} countMap={countMap} onDateChange={handleDateChange} onStatusChange={handleStatusChange} onSearch={handleSearch} onExport={handleDownload} onRefresh={getOrders} onBulkSend={handleBulkSend} /> */}

          <ListToolbar total={totalItems} countMap={countMap} onDateChange={handleDateChange}
                       onStatusChange={handleStatusChange} onSearch={handleSearch} onExport={handleDownload}
                       onRefresh={getOrders} onReset={handleReset}>
            <Box sx={{flex: 1, overflow: 'hidden'}}>
              <Grid container spacing={1.5} sx={{mb: 1.5}}>
                <Grid item>
                  <TextField
                    style={{width: 200}}
                    label="用户"
                    placeholder="用户"
                    autoComplete="off"
                    id="uid"
                    size="small"
                    value={filter.uid}
                    onClick={() => {
                      UserPicker({
                        onSelect(val) {
                          handleFilterChange("uid", val.uid);
                        },
                      });
                    }}
                  />
                </Grid>

                <Grid item>
                  <TextField
                    style={{width: 200}}
                    label="供应商"
                    placeholder="供应商"
                    autoComplete="off"
                    id="supplierId"
                    size="small"
                    value={supplier.name}
                    onClick={() => {
                      SupplierPicker({
                        onSelect(val) {
                          setSupplier(val);
                          handleFilterChange("supplierId", val.id);
                        },
                      });
                    }}
                  />
                </Grid>

                <Grid item>
                  <TextField
                    style={{width: 200}}
                    label="商品"
                    placeholder="商品"
                    autoComplete="off"
                    id="productId"
                    size="small"
                    value={product.name}
                    onClick={() => {
                      StoreProductPicker({
                        onSelect(val) {
                          setProduct(val);
                          handleFilterChange("productId", val.id);
                        },
                      });
                    }}
                  />
                </Grid>

                <Grid item>
                  <TextField
                    style={{width: 200}}
                    label="订单编号"
                    placeholder="订单编号"
                    autoComplete="off"
                    id="orderSN"
                    size="small"
                    value={filter.orderSN}
                    onChange={(e) => {
                      handleFilterChange("orderSN", e.target.value);
                    }}
                  />
                </Grid>

                <Grid item>
                  <TextField
                    style={{width: 200}}
                    label="物流编号"
                    placeholder="物流编号"
                    autoComplete="off"
                    id="deliverySN"
                    size="small"
                    value={filter.deliverySN}
                    onChange={(e) => {
                      handleFilterChange("deliverySN", e.target.value);
                    }}
                  />
                </Grid>

                <Grid item>
                  <FormControl size="small">
                    <InputLabel>状态</InputLabel>
                    <Select
                      label="状态"
                      multiple
                      value={filter.status}
                      onChange={(e) => {
                        handleFilterChange("status", e.target.value);
                      }}
                      style={{width: 200}}
                    >
                      {[-1, ...statuses].map((status, idx) => (
                        <MenuItem key={idx} value={status} name={status}>
                          {status == -1 ? "全部" : STORE_ORDER_STATUS_MAP[status]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item>
                  <FormControl size="small">
                    <InputLabel>支付方式</InputLabel>
                    <Select
                      label="支付方式"
                      value={filter.payMethod}
                      onChange={(e) => {
                        setFilter({
                          ...filter,
                          payMethod: e.target.value,
                        });
                      }}
                      style={{width: 200}}
                    >
                      {[-1, ...payMethods].map((type, idx) => (
                        <MenuItem key={idx} value={type} name={type}>
                          {idx == 0 ? "全部" : PAY_METHOD_MAP[type]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item>
                  <FormControl size="small">
                    <InputLabel>发货方式</InputLabel>
                    <Select
                      label="发货方式"
                      value={filter.deliveryType}
                      onChange={(e) => {
                        setFilter({
                          ...filter,
                          deliveryType: e.target.value,
                        });
                      }}
                      style={{width: 200}}
                    >
                      {[-1, "EXPRESS", "ZITI"].map((type, idx) => (
                        <MenuItem key={idx} value={type} name={type}>
                          {idx == 0 ? "全部" : DELIVERY_TYPE_MAP[type]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item>
                  <FormControl size="small">
                    <InputLabel>专区</InputLabel>
                    <Select
                      label="专区"
                      value={filter.sectionId || ""}
                      onChange={(e) => handleFilterChange("sectionId", e.target.value || null)}
                      style={{width: 200}}
                    >
                      <MenuItem value="">全部</MenuItem>
                      {storeSections.map((section) => (
                        <MenuItem key={section.id} value={section.id}>
                          {section.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
                    <DateTimePicker
                      views={["year", "day", "hours", "minutes", "seconds"]}
                      timeSteps={{minutes: 1, seconds: 1}}
                      ampm={false}
                      label="起始时间"
                      value={filter.startTime ? moment(filter.startTime) : null}
                      onChange={(newValue) => {
                        handleFilterChange("startTime", new Date(newValue));
                      }}
                      slotProps={{textField: {size: 'small', style: {width: 200}}}}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
                    <DateTimePicker
                      views={["year", "day", "hours", "minutes", "seconds"]}
                      timeSteps={{minutes: 1, seconds: 1}}
                      ampm={false}
                      label="终止时间"
                      value={filter.endTime ? moment(filter.endTime) : null}
                      onChange={(newValue) => {
                        handleFilterChange("endTime", new Date(newValue));
                      }}
                      slotProps={{textField: {size: 'small', style: {width: 200}}}}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>

              <Stack direction="row" spacing={1}>
                <Button component="label" variant="outlined" size="small">
                  批量发货
                  <input ref={uploadRef} hidden
                         accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                         type="file" onChange={(e) => handleUpload(e, 'faHuo')}/>
                </Button>
                <Button component="label" variant="outlined" size="small">
                  批量对账
                  <input ref={uploadRef} hidden
                         accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                         type="file" onChange={(e) => handleUpload(e, 'settle')}/>
                </Button>
                <Button variant="outlined" size="small" onClick={handleSupplyChainExport}>
                  供应链导出
                </Button>
              </Stack>
            </Box>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{minWidth: 800}}>
              <Table>
                <ListHead headLabel={TABLE_HEAD}/>
                <TableBody>
                  {orders.map((row) => {
                    const {
                      id,
                      uid,
                      settle,
                      payPrice,
                      payMethod,
                      deliveryType,
                      totalPrice,
                      deductionXfq,
                      deductionXfqV2,
                      deductionXfqV2Bak,
                      buyCount,
                      productData,
                      createdAt,
                      status,
                      orderSN,
                      userRemark,
                      adminRemark,
                      receiverAddress,
                      receiverName,
                      receiverMobile,
                      user,
                      supplier,
                      deductionDhqV2,
                      deductionPointsV2,
                      points,
                      sync,
                      syncRemark,
                      discountAmount,  // 支付优惠金额
                    } = row;
                    // const isItemSelected = selected.indexOf(nickname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell> */}
                        {/* <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Avatar alt={nickname} src={`${BASE_URL}${avatar}`} />
                              <Typography variant="subtitle2" noWrap>
                                {nickname || uid}
                              </Typography>
                            </Stack>
                          </TableCell> */}
                        <TableCell align="left">
                          <UserInfo {...user} />
                        </TableCell>
                        <TableCell align="left" sx={{minWidth: 300}}>
                          <Stack>
                            <Typography>
                              {productData.map((p) => (
                                <Stack direction="row" spacing={1}>
                                  <CellImage src={p.cover} style={{width: 60, height: 60, objectFit: "contain"}}/>
                                  <Stack>
                                    <Typography>{p.name}</Typography>
                                    <Typography color="primary" fontSize={14}
                                                sx={{display: "inline"}}>【{sectionMap[p.sectionId]}】
                                      x {p.count}</Typography>
                                  </Stack>
                                </Stack>
                              ))}
                            </Typography>
                            <Typography>订单编号：{orderSN}</Typography>
                            <Typography>下单时间：{createdAt}</Typography>
                            <Typography>订单状态：<Label variant="ghost" color={ConvertUtil.getOrderStatusColor(status)}>
                              {ConvertUtil.getOrderStatusText(status)}
                            </Label></Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left" sx={{minWidth: 180}}>
                          <Stack direction="row">
                            订单金额：{totalPrice}
                          </Stack>
                          {discountAmount && Number(discountAmount) > 0 ?
                            (<Stack direction="row" sx={{color: '#FF6B35', fontWeight: 'bold'}}>
                              优惠金额：-{discountAmount}
                            </Stack>) : null
                          }
                          {payPrice && Number(payPrice) > 0 ?
                            (<Stack direction="row">
                              实付金额：{payPrice}
                            </Stack>) : null
                          }
                          <Stack direction="row">
                            支付方式：{PAY_METHOD_MAP[payMethod]}
                          </Stack>
                          {deductionDhqV2 && Number(deductionDhqV2) > 0 ?
                            (<Stack direction="row">
                              兑换券：{deductionDhqV2}
                            </Stack>) : null
                          }
                          {deductionXfqV2 && Number(deductionXfqV2) > 0 ?
                            (<Stack direction="row">
                              权益金：{deductionXfqV2}
                            </Stack>) : null
                          }
                          {deductionXfqV2Bak && Number(deductionXfqV2Bak) > 0 ?
                            (<Stack direction="row">
                              消费券：{deductionXfqV2Bak}
                            </Stack>) : null
                          }
                          {deductionPointsV2 && Number(deductionPointsV2) > 0 ?
                            (<Stack direction="row">
                              绿积分：{deductionPointsV2}
                            </Stack>) : null
                          }
                          {points && Number(points) > 0 ?
                            (<Stack direction="row">
                              <Typography sx={{
                                color: "#ff4a00",
                                display: "inline-block",
                                verticalAlign: "middle"
                              }}>赠送积分：{points}</Typography>
                            </Stack>) : null
                          }
                        </TableCell>
                        <TableCell align="left" sx={{minWidth: 240}}>
                          {deliveryType == "ZITI" ? (
                            <Stack>
                              <Typography>自提</Typography>
                              <Typography>买家留言：{userRemark}</Typography>
                              <Typography>管理员备注：{adminRemark}</Typography>
                            </Stack>
                          ) : (
                            <Stack>
                              <Typography>收件人：{receiverName}</Typography>
                              <Typography>电话：{receiverMobile}</Typography>
                              <Typography>地址：{receiverAddress}</Typography>
                              <Typography>买家留言：{userRemark}</Typography>
                              <Typography>管理员备注：{adminRemark}</Typography>
                            </Stack>
                          )}
                        </TableCell>
                        <TableCell align="left" sx={{minWidth: 150}}>
                          <Stack>
                            <Typography>{supplier?.name}</Typography>
                            {(supplier && supplier.id == 868) && ((sync && sync == 0) || (sync && sync == 1)) ?
                              (<Typography fontSize={14}
                                           color="secondary">{sync && sync == 0 ? '【待传输】' : sync && sync == 1 ? '【已传输】' : ''}</Typography>
                              ) : null
                            }
                            {(sync && sync != 0) && (sync && sync != 1) ?
                              (<Stack>
                                <Tooltip title={syncRemark || "传输失败，未知错误"}>
                                  <Typography fontSize={14} color="red"
                                              sx={{display: "inline-block"}}>【传输失败】</Typography>
                                </Tooltip>
                              </Stack>) : null
                            }
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Switch checked={!!settle} onChange={(e) => handleMoreClick('settle', row)}/>
                        </TableCell>
                        {/* <TableCell align="left">{deductionXfqV2}</TableCell> */}

                        {/* <TableCell align="left">{buyCount}</TableCell> */}

                        {/* <TableCell align="left">{totalPrice}</TableCell> */}
                        {/* <TableCell align="left">{payPrice}</TableCell> */}
                        {/* <TableCell align="left">{PAY_METHOD_MAP[payMethod]}</TableCell> */}
                        {/*<TableCell align="left">*/}
                        {/*  <Label variant="ghost" color={ConvertUtil.getOrderStatusColor(status)}>*/}
                        {/*    {ConvertUtil.getOrderStatusText(status)}*/}
                        {/*  </Label>*/}
                        {/*</TableCell>*/}
                        {/* <TableCell align="left">{points}</TableCell> */}
                        {/*<TableCell align="left">{deliveryType == 'EXPRESS' ? '快递配送' : '自提'}</TableCell>*/}
                        {/*<TableCell align="left">{userRemark}</TableCell>*/}
                        <TableCell align="right">
                          <Stack direction="row">
                            <Button
                              variant="text"
                              onClick={() => {
                                setCurOrder(row);
                                setAction("detail");
                              }}
                            >
                              详情
                            </Button>
                            <MoreMenu spread={false} menus={filterMoreMenus(status)}
                                      onMoreClick={(title) => handleMoreClick(title, row)}/>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{height: 53 * emptyRows}}>
                      <TableCell colSpan={6}/>
                    </TableRow>
                  )}
                </TableBody>
                {orders.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{py: 3}}>
                        <SearchNotFound searchQuery={filter.search}/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" sx={{p: 2}}>
              {/* <Typography variant="caption" component="span">
                预期利润：{100}
              </Typography>
              <Divider orientation="vertical" flexItem sx={{mx: 1}} />
              <Typography variant="caption" component="span" >
                完单利润：{100}
              </Typography> */}
            </Stack>
            <TablePagination labelRowsPerPage="每页行数" rowsPerPageOptions={[10, 20]} component="div"
                             count={totalItems} rowsPerPage={filter.size} page={filter.page}
                             onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage}/>
          </Stack>
        </Card>
      </Container>

      {/* 详情 */}
      <OrderDetailDialog order={curOrder} open={action === "detail"} onClose={() => setAction()}/>

      {/* 记录 */}
      <OrderRecordsDialog rows={records} open={action === "records"} onClose={() => setAction()}/>

      <FormDialog title={`订单${curOrder.orderSN}备注`} open={action === "remark"} onConfirm={handleDialogConfirm}
                  onClose={() => setAction()}>
        <TextField autoComplete="false" autoFocus id="adminRemark" value={remark} label="管理员备注" fullWidth
                   variant="standard" onChange={(e) => setRemark(e.target.value)}/>
      </FormDialog>
      <FormDialog title={`订单${curOrder.orderSN}备注`} open={action === "cancel"} onConfirm={syncRemarkConfirm}
                  onClose={() => setAction()}>
        <TextField autoComplete="false" autoFocus id="adminRemark" value={syncRemark} label="管理员备注" fullWidth
                   variant="standard" onChange={(e) => setSyncRemark(e.target.value)}/>
      </FormDialog>
      <FormDialog title={`订单${curOrder.orderSN}发货`} open={action === "delivery"} onConfirm={handleDialogConfirm}
                  onClose={() => setAction()}>
        <TextField autoComplete="false" autoFocus id="transport" value={deliverySN} label="物流单号"
                   placeholder="(选填)" fullWidth variant="standard" onChange={(e) => setDeliverySN(e.target.value)}/>
      </FormDialog>

      {action == "addOrder" && (
        <StoreOrderAddDialog
          open
          onFinish={() => {
            getOrders();
            setAction("");
          }}
          onClose={() => setAction("")}
        />
      )}
    </Page>
  );
}
